import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_PAYMENT + '/coupon'
import queryString from 'query-string'

const fetch = (params) => {
  return Repository(baseURL).fetch(params)
}

const count = (params) => {
  return Repository(baseURL + '/count').fetch(params)
}

const fetchOne = (id) => {
  return Repository(baseURL).fetchOne(id)
}

const create = (params) => {
  return Repository(baseURL + '/create').create(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

const remove = (id) => {
  return Repository(baseURL).delete(id)
}

const createMany = (params) => {
  return Repository(baseURL).createMany(params)
}
const fetchReport = (params) => {
  const query = queryString.stringify(
    {
      ...params,
    },
    {arrayFormat: 'repeat'}
  )
  return Repository(`${baseURL}/get-report?${query}`).fetch()
}
const fetchReportAll = (params) => {
  return Repository(`${baseURL}/get-all-report`).fetch(params)
}
export default {
  fetch,
  fetchOne,
  create,
  createMany,
  update,
  remove,
  count,
  fetchReport,
  fetchReportAll,
}
